
function HomePage() {
  return (
    <div className="bg-[#fdfcf7] text-gray-800 font-sans flex">
      <div className="flex-1 flex flex-col">
        <section className="flex flex-col md:flex-row items-center justify-between px-10 py-20">
          <div className="max-w-xl">
            <h2 className="text-5xl font-bold text-[#2c2c2c] leading-tight mb-6">
              부드러움이 <br />당신의 일상에 스며들다
            </h2>
            <p className="text-gray-600 text-lg mb-8">
              Creamoff는 차분함과 여유를 담은 프리미엄 브랜드입니다.<br />
              우리는 감각적인 디자인과 따뜻한 경험을 추구합니다.
            </p>
            <button className="bg-[#1a1a1a] text-white px-6 py-3 rounded-full hover:bg-[#333] transition">
              더 알아보기
            </button>
          </div>
        </section>

        {/* 푸터 */}
        {/* <footer className="mt-auto p-6 text-center text-sm text-gray-400">
          © 2025 Creamoff. All rights reserved.
        </footer> */}
      </div>
    </div>
  );
}

export default HomePage;
